export default __webpack_public_path__ + "static/Homepage-animation-9630980222a77652a3bf2ec2d73b866d.mp4";